import { withTracking } from '../../../observability';
import { SectionName } from '../../../observability/tracking/events';
import { createBuilderModule } from '../../../builder';
import { COLOR_KEYS } from '../../../constants';
import { DEFAULT_VALUES } from './fixtures';
import { CompactCTASection } from './CompactCTASection';

export default createBuilderModule(
  withTracking(CompactCTASection, {
    sectionName: SectionName.CompactCTASection,
  }),
  {
    name: 'CompactCTASection',
    image: 'https://cdn.zappy.app/26523527dbfc73189300e09db2be9552.svg',
    inputs: [
      {
        name: 'heading',
        type: 'string',
        required: true,
        defaultValue: DEFAULT_VALUES.heading,
      },
      {
        name: 'ctaText',
        type: 'string',
        required: true,
        defaultValue: DEFAULT_VALUES.ctaText,
      },
      {
        name: 'ctaUrl',
        type: 'string',
        required: true,
        defaultValue: DEFAULT_VALUES.ctaUrl,
      },
      {
        name: 'backgroundColor',
        type: 'string',
        enum: [COLOR_KEYS.cream, COLOR_KEYS.zapier],
        required: true,
        defaultValue: DEFAULT_VALUES.backgroundColor,
      },
      {
        name: 'isFullWidth',
        type: 'boolean',
        required: true,
        defaultValue: DEFAULT_VALUES.isFullWidth,
      },
    ],
  },
);
